import { SELLER_LOGIN, BUYER_LOGIN } from '../Action/type';

const initialState = {
    isResistered: false,
    user: {}
}

export default function(state = initialState, action) {
    switch (action.type) {
        case SELLER_LOGIN:
            return {
                ...state,
                user: action.payload
            };
        case BUYER_LOGIN:
            return {
                ...state,
                user: action.payload
            };

        default:
            return state;
    }

}